// Single source of truth for personal/contact information.
// Only real, verified details belong here.

const PUBLIC = process.env.PUBLIC_URL || "";

export const profile = {
  name: "Gokul Raj",
  role: "Full-Stack Software Engineer",
  headline: "Mobile apps and the backends behind them.",
  summary:
    "I build production mobile applications with React Native and the Node.js, Express and database layers that power them, from Figma screens to AWS deployment.",
  bio: [
    "I'm a software engineer who specialises in mobile application development. Most of my work is cross-platform apps built with React Native and JavaScript, shipped to the Google Play Store for retail, grocery, real estate, finance, logistics and hiring products.",
    "I don't stop at the client. I build server-side features with Node.js and Express, model data in MongoDB and MySQL, and deploy backend services to AWS. I also design interfaces in Figma, so I can take a feature from wireframe to a working screen backed by a real API.",
  ],
  email: "gokulraj.mobiledev@gmail.com",
  phone: "+91 8438729376",
  phoneHref: "tel:+918438729376",
  location: "Salem, Tamil Nadu, India",
  languages: ["English", "Tamil"],
  resumeUrl: `${PUBLIC}/images/Resume.pdf`,
  photo: `${PUBLIC}/images/profile.png`,
};

export const socials = [
  {
    id: "github",
    label: "GitHub",
    handle: "GokulRajprince",
    url: "https://github.com/GokulRajprince",
  },
  {
    id: "linkedin",
    label: "LinkedIn",
    handle: "gokul-raj-m",
    url: "https://www.linkedin.com/in/gokul-raj-m-97008b228/",
  },
  {
    id: "instagram",
    label: "Instagram",
    handle: "me_gokulraj",
    url: "https://instagram.com/me_gokulraj?igshid=YTQwZjQ0Nml0OA==",
  },
];

export const navLinks = [
  { to: "/", label: "Home", end: true },
  { to: "/about", label: "About" },
  { to: "/projects", label: "Projects" },
  { to: "/experience", label: "Experience" },
  { to: "/services", label: "Services" },
  { to: "/contact", label: "Contact" },
];
